var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcLock16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.957 6.086V4.929c0-1.08-1.05-1.929-2.1-1.929s-2.1.849-2.1 1.929v1.157c-.45 0-.9.463-.9.925v2.7c0 .54.45 1.003.9 1.003h4.125c.525 0 .975-.463.975-.925v-2.7c0-.54-.45-1.003-.9-1.003m-.975 0h-2.25V4.929c0-.618.525-1.003 1.125-1.003s1.125.385 1.125 1.003z"
})));
export default SvgIcLock16;